const React = require('react');
import EvidenceCardMainContainer from './evidenceCard.jsx.js';
const ReduxStore = require('./redux/reduxStore.jsx.js');
const SharedConstants = require('../../../shared/sharedConstants');
const AjaxFunctions = require('./ajaxFunctions');
const AdminAjaxFunctions = require('./adminAjaxFunctions');
const ToastAlert = require('./components/toastAlert');
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button/Button";

export class EvidenceCardReview extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         questionTemplates: [],
      }
   }

   componentDidMount(){
      ReduxStore.store.dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(this.props.curCard));
   }

   render() {
      return (
         <div id='evidenceReviewContainer'>
            <EvidenceCardMainContainer
               userData={{}}
               isReviewing={true}
               showAdditionalFunctions={false}
            />
            <hr style={{'paddingTop': '10px', 'paddingBottom': '10px'}} />
            <ApprovalControl
               idCard={this.props.curCard.id}
               closeFunction={this.props.closeFunction}
            />
         </div>
      );
   }
}

export class ApprovalControl extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         questionTemplates: [],
         idSelectedTemplate: -1,
         commentText: '',
      }
   }

   componentDidMount(){
      AjaxFunctions.getReviewQuestionTemplates()
         .then(data => { this.setState({ questionTemplates: data }); })
         .catch(err => { ToastAlert.error(err); });
   }

   submitCardVote() {
      const { idCard } = this.props;
      const { idSelectedTemplate, commentText } = this.state;
      if ((window.globals.isSponsor || window.globals.isAdmin) && idSelectedTemplate > 8) {
         if (idSelectedTemplate == 10) {
            AdminAjaxFunctions.manuallyApproveEvidence(idCard).then(() => {
               ToastAlert.success('Instantly approved evidence.');
               this.props.closeFunction();
            });
         } else if (idSelectedTemplate == 11) {
            AdminAjaxFunctions.manuallyRejectEvidence(idCard, commentText).then(() => {
               ToastAlert.success('Instantly rejected evidence.');
               this.props.closeFunction();
            });
         }
      } else {
         AjaxFunctions.createEvidenceApproval(idCard, idSelectedTemplate, commentText).then(() => {
            ToastAlert.success('Vote submitted.');
            this.props.closeFunction();
         });
      }
   }

   render() {
      let questions = this.state.questionTemplates.map((template) => {
         if (template.orderNumber < 0) return null;
         return (
            <div className="review-question" key={template.id}>
               <div
                  className={'review-btn review-btn-yes ' + (this.state.idSelectedTemplate === template.id ? 'yes': '')}
                  onClick={() => this.setState({idSelectedTemplate: template.id})}
               >
                  {template.text}
               </div>
               <div className={'review-question-comment'}>
                  {(template.textPrompt && template.id === this.state.idSelectedTemplate) ?
                     <>
                        <TextField
                           id={'reviewTemplateTextField' + template.id}
                           label={template.textPrompt}
                           multiline
                           rowsMax="50"
                           onChange={(event) => this.setState({commentText: event.target.value})}
                           className={''}
                           margin="normal"
                           maxLength={1000}
                           value={this.state.commentText}
                        />
                     </>
                  : ''}
                  {template.id === this.state.idSelectedTemplate && 
                     <Button 
                        onClick={() => this.submitCardVote()}
                        style={{ textTransform: 'none' }} 
                        color='primary' 
                        variant='outlined'
                        size='small'
                     >
                        <div>Submit</div>
                     </Button>
                  }
               </div>
            </div>
         )
      });
      return(
         <div className='approval-control-container'>
            <div className='questions'>
               <div className='section-text evidence-review-right-column'>
                  <div className="section-text-buttons">
                     <div>Select one review comment for the evidence &micro;Pub</div>
                     {questions}
                  </div>
                  <div className={'card'}>
                     <div className={'card-body'}>
                        <div>Remember, good &micro;Pubs. . .</div>
                        <ul>
                           <li>Are clearly written</li>
                           <li>Are plausible and useful</li>
                           <li>Describe a tangible finding or result</li>
                           <li>Cite a recognized and trustworthy source.  Appropriate sources of evidence include primary papers, patents and review articles from peer-reviewed technical publications&#8212;published journal articles or articles on pre-print servers. Secondary reporting from digests and newspapers is not appropriate.</li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}
